import React from 'react'

function Footer() {
  return (
    <div>
      <footer className="margin-t-80">
        <div className="container">
          <div className="br-footer-detail">
            <div className="br-copy">
              Copyright © <a className="site-name" target='_blank' rel='noreferrer' href="https://landing.parceirando.com.br">Parceirando</a> todos os direitos reservados.
            </div>
            <div className="br-social">
              <ul>
                <li><a href="https://www.facebook.com/parceirando" rel='noreferrer' target="_blank"><i className="fa-brands fa-facebook"></i></a></li>
                <li><a href="https://www.instagram.com/parceirando/" rel='noreferrer' target="_blank"><i className="fa-brands fa-instagram"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer
